import { FocusAreaViewOptional } from "@/domain/focus-area/components/focus-area-view-optional";
import { DatatableRowData, SubSectionData } from "@/domain/view/components/datatable/datatable-types";
import { Row } from "@tanstack/react-table";

import { useGetFocusArea } from "../../hooks/api/use-get-focus-area";

export interface DatatableFocusAreaSubSectionHeaderProps<TData extends DatatableRowData> {
  data: SubSectionData<TData>;
  currentRow: Row<SubSectionData<TData>>;
}

export const DatatableFocusAreaSubSectionHeader = <TData extends DatatableRowData>({
  data,
  currentRow,
}: DatatableFocusAreaSubSectionHeaderProps<TData>) => {
  const { focusArea } = useGetFocusArea({ id: data.key });
  const count = currentRow.subRows.length;

  return (
    <div className="flex h-full flex-row items-center justify-start gap-2 px-2">
      <div className="flex flex-row items-center justify-start gap-2">
        <FocusAreaViewOptional focusArea={focusArea} logoOnly={true} className="h-3.5 w-3.5" />
        <span className="text-xs text-muted-foreground">{count}</span>
      </div>
      <div className="flex grow flex-row items-center pl-2">
        <div className="h-px w-full bg-foreground/10" />
      </div>
    </div>
  );
};
